import { PROMO_CARDS } from 'src/selectors'

import { PromoCard } from './PromoCard'
import styles from './PromoCards.module.scss'

import type { SanityPromoCard } from 'src/types/HomepageContent'

interface PromoCardsProps {
  promotionCards: SanityPromoCard[]
}

export const PromoCards = ({ promotionCards }: PromoCardsProps) => (
  <div className={styles.grid} data-cy={PROMO_CARDS}>
    {promotionCards.map((item, index) => (
      <PromoCard
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        imageId={item.image.cdnImage}
        altText={item.image.altText}
        title={item.title}
        text={item.text}
        link={item.link}
      />
    ))}
  </div>
)
